module.exports = __webpack_public_path__ + "staticfr/media/marcasr.31924bd3.jpg";